import { Minus } from '@phosphor-icons/react';
import { Tip } from '~/components/ui/tip';
import { useWindowChrome } from './window-system';

/**
 * FRONT-3146: the title bar's Minimize control. Renders only while the surface
 * is docked in the window layer — a standalone full-screen overlay has no bar
 * to minimize into. Escape CLOSES the window under the mouse (eddy,
 * 2026-10-26), so this hint no longer names it.
 */
export function WindowMinimizeButton({ className }: { className?: string }) {
  const chrome = useWindowChrome();
  if (!chrome.docked) return null;
  return (
    <Tip label="Minimize">
      <button
        type="button"
        onClick={chrome.minimize}
        aria-label="Minimize"
        data-testid="window-minimize"
        className={
          className ??
          'size-8 inline-flex items-center justify-center rounded-[10px] text-foreground hover:bg-muted transition-colors'
        }
      >
        <Minus size={18} />
      </button>
    </Tip>
  );
}
